import { jsxs as l, jsx as e, Fragment as V } from "react/jsx-runtime";
import { c as i } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
import { T as v } from "./Typography-DjQwU5Xn.js";
import { A as fe } from "./Alert-CFjABKUQ.js";
import _, { forwardRef as he, useRef as K, useId as xe, useEffect as U, useState as A } from "react";
import { I as G, B as j } from "./Input-s7q1Bymv.js";
import { C as ge, F as pe, S as be, L as ve, a as Ne } from "./star-DOuYjd62.js";
import { C as ye, D as we, N as J, E as ke } from "./DataGrid-C7ruANGS.js";
import { C as ae } from "./check-CVfLJTWr.js";
import { D as te, P as le } from "./KanbanBoard-qgBeD7kn.js";
import { P as Ce } from "./plus-B9IpBnee.js";
import { B as Q } from "./Badge-CljJSGSb.js";
import { C as q } from "./Card-1TvXi1hD.js";
import { T as ne, u as Se, b as $e, c as Pe, d as je, e as De, f as Ee } from "./Toast-Bx97RvZK.js";
import { L as ce, E as de } from "./Section-DbfMk74d.js";
import { A as Te } from "./Avatar-BzalLvjS.js";
const br = ({
  onSubmit: s,
  title: a,
  description: c,
  error: n,
  children: r,
  className: d,
  ...o
}) => /* @__PURE__ */ l(
  "form",
  {
    onSubmit: (h) => {
      h.preventDefault(), s == null || s(h);
    },
    className: i("space-y-6", d),
    ...o,
    children: [
      (a || c) && /* @__PURE__ */ l("div", { className: "mb-6", children: [
        a && /* @__PURE__ */ e(v, { variant: "h3", className: "mb-2 text-foreground", children: a }),
        c && /* @__PURE__ */ e(v, { variant: "body", className: "text-muted-foreground", children: c })
      ] }),
      n && /* @__PURE__ */ e(fe, { variant: "error", title: "Error", description: n }),
      /* @__PURE__ */ e("div", { className: "space-y-4", children: r })
    ]
  }
);
function Z() {
  const { toasts: s } = Se();
  return /* @__PURE__ */ l(ne, { children: [
    s.map(function({ id: a, title: c, description: n, action: r, variant: d, ...o }) {
      return /* @__PURE__ */ l($e, { ...o, className: i(d === "destructive" ? "destructive group border-[var(--ds-color-border-danger)] bg-[var(--ds-color-bg-danger-subtle)] text-[var(--ds-color-fg-danger)]" : d === "success" ? "border-[var(--ds-color-bg-success-default)] bg-[var(--ds-color-bg-success-subtle)] text-[var(--ds-color-fg-default)]" : ""), children: [
        /* @__PURE__ */ l("div", { className: "grid gap-1", children: [
          c && /* @__PURE__ */ e(Pe, { children: c }),
          n && /* @__PURE__ */ e(je, { children: n })
        ] }),
        r,
        /* @__PURE__ */ e(De, {})
      ] }, a);
    }),
    /* @__PURE__ */ e(Ee, { "aria-label": "Notifications", role: "region" })
  ] });
}
const vr = ne, Ie = he(({
  label: s,
  id: a,
  ariaLabel: c,
  value: n,
  onChange: r,
  min: d,
  max: o,
  disabled: p,
  error: h,
  helperText: m,
  className: f,
  ...t
}, u) => {
  const b = K(null), N = xe(), x = a ?? N, w = !s && !c;
  U(() => {
    process.env.NODE_ENV !== "production" && w && console.warn("DatePicker requires a label or ariaLabel for an accessible name.");
  }, [w]);
  const y = u || b, S = () => {
    !p && y.current && (typeof y.current.showPicker == "function" ? y.current.showPicker() : y.current.focus());
  };
  return /* @__PURE__ */ l("div", { className: i("flex flex-col gap-1.5", f), ...t, children: [
    s && /* @__PURE__ */ e("label", { htmlFor: x, className: "text-sm font-medium text-[var(--ds-color-fg-default)]", children: s }),
    /* @__PURE__ */ l("div", { className: "relative", children: [
      /* @__PURE__ */ e(
        G,
        {
          ref: y,
          id: x,
          type: "date",
          value: n,
          onChange: (E) => r == null ? void 0 : r(E.target.value),
          min: d,
          max: o,
          disabled: p,
          hasError: !!h,
          "aria-label": s ? void 0 : c,
          "aria-describedby": m && !h ? `${x}-help` : void 0,
          className: i(
            "pl-10"
          )
        }
      ),
      /* @__PURE__ */ e(
        "div",
        {
          className: "absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none",
          onClick: S,
          children: /* @__PURE__ */ e(ge, { className: "h-4 w-4" })
        }
      )
    ] }),
    m && !h && /* @__PURE__ */ e(v, { id: `${x}-help`, variant: "caption", className: "text-[var(--ds-color-fg-muted)]", children: m }),
    h && /* @__PURE__ */ e(v, { id: `${x}-error`, variant: "caption", className: "text-[var(--ds-color-fg-error)]", children: h })
  ] });
});
Ie.displayName = "DatePicker";
const Nr = ({
  options: s,
  value: a,
  onChange: c,
  multiple: n,
  values: r,
  onValuesChange: d,
  label: o,
  placeholder: p = "Select an option...",
  disabled: h,
  error: m,
  helperText: f,
  onSearch: t,
  id: u,
  loading: b,
  className: N,
  ...x
}) => {
  var re;
  const [w, y] = A(!1), [S, E] = A(""), T = K(null), z = K(null), I = K(null), [$, P] = A(-1), [F, W] = A(a), [M, H] = A(r ?? []), L = a !== void 0, B = L ? a : F, k = r !== void 0, R = k ? r : M, D = t ? s : s.filter((g) => g.label.toLowerCase().includes(S.toLowerCase())), Y = s.find((g) => g.value === B), ie = s.filter((g) => R.includes(g.value)), oe = w ? S : n ? ie.map((g) => g.label).join(", ") : Y ? Y.label : "";
  U(() => {
    w || (E(""), P(-1));
  }, [w]), U(() => {
    const g = (C) => {
      T.current && !T.current.contains(C.target) && y(!1);
    };
    return document.addEventListener("mousedown", g), () => document.removeEventListener("mousedown", g);
  }, []);
  const X = (g) => {
    var C, O;
    if (n) {
      const se = R.includes(g) ? R.filter((ue) => ue !== g) : [...R, g];
      k || H(se), d == null || d(se), E(""), (C = I.current) == null || C.focus();
      return;
    }
    L || W(g), c == null || c(g), y(!1), (O = I.current) == null || O.focus();
  }, me = (g) => {
    if (!h) {
      if (!w) {
        (g.key === "ArrowDown" || g.key === "Enter" || g.key === " ") && (g.preventDefault(), y(!0));
        return;
      }
      switch (g.key) {
        case "ArrowDown":
          g.preventDefault(), P((C) => (C + 1) % D.length), ee(($ + 1) % D.length);
          break;
        case "ArrowUp":
          g.preventDefault(), P((C) => (C - 1 + D.length) % D.length), ee(($ - 1 + D.length) % D.length);
          break;
        case "Enter":
          g.preventDefault(), $ >= 0 && $ < D.length && X(D[$].value);
          break;
        case "Escape":
          g.preventDefault(), y(!1);
          break;
        case "Tab":
          y(!1);
          break;
      }
    }
  }, ee = (g) => {
    var O;
    const C = (O = z.current) == null ? void 0 : O.children[g];
    C == null || C.scrollIntoView({ block: "nearest" });
  };
  return /* @__PURE__ */ l(
    "div",
    {
      className: i("flex flex-col gap-1.5 relative", N),
      ref: T,
      onKeyDown: me,
      ...x,
      children: [
        o && /* @__PURE__ */ e("label", { className: "text-sm font-medium text-[var(--ds-color-fg-default)]", onClick: () => {
          var g;
          return (g = I.current) == null ? void 0 : g.focus();
        }, children: o }),
        /* @__PURE__ */ l(
          "div",
          {
            className: "relative",
            children: [
              /* @__PURE__ */ e(
                G,
                {
                  id: u,
                  ref: I,
                  type: "text",
                  value: oe,
                  onChange: (g) => {
                    E(g.target.value), w || y(!0), t == null || t(g.target.value), P(0);
                  },
                  onClick: () => !h && y(!0),
                  placeholder: p,
                  disabled: h,
                  hasError: !!m,
                  className: "pr-10 cursor-pointer",
                  readOnly: !w,
                  role: "combobox",
                  "aria-expanded": w,
                  "aria-controls": "combobox-list",
                  "aria-activedescendant": $ >= 0 ? `option-${(re = D[$]) == null ? void 0 : re.value}` : void 0,
                  autoComplete: "off"
                }
              ),
              /* @__PURE__ */ e(
                "div",
                {
                  className: "absolute right-3 top-1/2 -translate-y-1/2 text-[var(--ds-color-fg-muted)] pointer-events-none",
                  children: /* @__PURE__ */ e(ye, { className: "h-4 w-4" })
                }
              )
            ]
          }
        ),
        w && !h && /* @__PURE__ */ e("div", { className: "absolute top-full mt-1 w-full z-50 rounded-[var(--ds-radius-md)] border border-[var(--ds-color-border-default)] bg-[var(--ds-color-bg-surface-default)] shadow-elevation-3 max-h-60 overflow-auto", children: b ? /* @__PURE__ */ e("div", { className: "p-2 text-sm text-[var(--ds-color-fg-muted)]", children: "Loading..." }) : D.length === 0 ? /* @__PURE__ */ e("div", { className: "p-2 text-sm text-[var(--ds-color-fg-muted)]", children: "No results found." }) : /* @__PURE__ */ e("ul", { role: "listbox", id: "combobox-list", ref: z, "aria-multiselectable": n || void 0, children: D.map((g, C) => /* @__PURE__ */ l(
          "li",
          {
            id: `option-${g.value}`,
            role: "option",
            "aria-selected": n ? R.includes(g.value) : B === g.value,
            onClick: (O) => {
              O.stopPropagation(), X(g.value);
            },
            onMouseEnter: () => P(C),
            className: i(
              "flex items-center justify-between px-3 py-2 text-sm cursor-pointer",
              $ === C ? "bg-[var(--ds-color-bg-surface-hover)]" : "",
              (n ? R.includes(g.value) : B === g.value) && "bg-[var(--ds-color-bg-primary-subtle)] text-[var(--ds-color-fg-primary)]"
            ),
            children: [
              /* @__PURE__ */ e("span", { children: g.label }),
              (n ? R.includes(g.value) : B === g.value) && /* @__PURE__ */ e(ae, { className: "h-4 w-4" })
            ]
          },
          g.value
        )) }) }),
        f && !m && /* @__PURE__ */ e(v, { variant: "caption", className: "text-[var(--ds-color-fg-muted)]", children: f }),
        m && /* @__PURE__ */ e(v, { variant: "caption", className: "text-[var(--ds-color-fg-error)]", children: m })
      ]
    }
  );
}, yr = ({
  title: s,
  description: a,
  confirmLabel: c = "Confirm",
  cancelLabel: n = "Cancel",
  onConfirm: r,
  onCancel: d,
  variant: o = "info",
  isLoading: p,
  isOpen: h,
  onClose: m,
  ...f
}) => {
  const t = () => {
    d == null || d(), m();
  };
  return /* @__PURE__ */ e(te, { isOpen: h, onClose: t, title: s, ...f, children: /* @__PURE__ */ l("div", { className: "space-y-4", children: [
    /* @__PURE__ */ e(v, { variant: "body", className: "text-muted-foreground", children: a }),
    /* @__PURE__ */ l("div", { className: "flex justify-end gap-3 mt-6", children: [
      /* @__PURE__ */ e(j, { variant: "outline", onClick: t, disabled: p, children: n }),
      /* @__PURE__ */ e(
        j,
        {
          variant: o === "danger" ? "danger" : "primary",
          onClick: () => {
            r();
          },
          isLoading: p,
          children: c
        }
      )
    ] })
  ] }) });
}, wr = ({
  options: s,
  multiple: a = !1,
  selectedIds: c,
  onSelectionChange: n,
  confirmLabel: r = "Confirm",
  cancelLabel: d = "Cancel",
  onConfirm: o,
  allowCreate: p = !1,
  createPlaceholder: h = "Enter name...",
  onCreate: m,
  createLabel: f = "Create & Select",
  createActionLabel: t = "Create New",
  maxOptionsHeight: u = "15rem",
  emptyState: b,
  loading: N = !1,
  isOpen: x,
  onClose: w,
  ...y
}) => {
  const [S, E] = A([]), [T, z] = A(!1), [I, $] = A(""), P = c ?? S, F = (k) => {
    E(k), n == null || n(k);
  }, W = (k) => {
    F(
      a ? P.includes(k) ? P.filter((R) => R !== k) : [...P, k] : [k]
    );
  }, M = () => {
    o == null || o(P), L();
  }, H = () => {
    I.trim() && m && (m(I.trim()), $(""), z(!1));
  }, L = () => {
    F([]), z(!1), $(""), w();
  }, B = T ? void 0 : /* @__PURE__ */ l("div", { className: "flex gap-3 justify-end", children: [
    /* @__PURE__ */ e(j, { variant: "outline", onClick: L, children: d }),
    /* @__PURE__ */ e(
      j,
      {
        disabled: P.length === 0,
        onClick: M,
        children: r
      }
    )
  ] });
  return /* @__PURE__ */ e(
    te,
    {
      isOpen: x,
      onClose: L,
      footer: B,
      size: "md",
      ...y,
      children: /* @__PURE__ */ e("div", { className: "py-2", children: N ? /* @__PURE__ */ e("div", { className: "flex items-center justify-center py-8", children: /* @__PURE__ */ e("div", { className: "animate-spin h-6 w-6 border-2 border-primary border-t-transparent rounded-full" }) }) : T ? (
        // Create New Form
        /* @__PURE__ */ l("div", { className: "space-y-4", children: [
          /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
            G,
            {
              value: I,
              onChange: (k) => $(k.target.value),
              placeholder: h,
              autoFocus: !0
            }
          ) }),
          /* @__PURE__ */ l("div", { className: "flex gap-2", children: [
            /* @__PURE__ */ e(
              j,
              {
                variant: "outline",
                className: "flex-1",
                onClick: () => {
                  z(!1), $("");
                },
                children: d
              }
            ),
            /* @__PURE__ */ e(
              j,
              {
                className: "flex-1",
                disabled: !I.trim(),
                onClick: H,
                children: f
              }
            )
          ] })
        ] })
      ) : /* @__PURE__ */ l(V, { children: [
        s.length > 0 ? /* @__PURE__ */ e(
          "div",
          {
            className: "space-y-2 overflow-y-auto",
            style: { maxHeight: u },
            children: s.map((k) => /* @__PURE__ */ l(
              "label",
              {
                className: i(
                  "flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors",
                  k.disabled && "opacity-50 cursor-not-allowed",
                  P.includes(k.id) ? "border-primary bg-primary/5" : "border-border hover:border-border-hover"
                ),
                children: [
                  /* @__PURE__ */ e(
                    "input",
                    {
                      type: a ? "checkbox" : "radio",
                      name: "selection",
                      value: k.id,
                      checked: P.includes(k.id),
                      onChange: () => !k.disabled && W(k.id),
                      disabled: k.disabled,
                      className: "sr-only"
                    }
                  ),
                  k.icon || /* @__PURE__ */ e(pe, { className: "h-5 w-5 text-muted-foreground" }),
                  /* @__PURE__ */ l("div", { className: "flex-1 min-w-0", children: [
                    /* @__PURE__ */ e(v, { variant: "body", className: "font-medium truncate", children: k.label }),
                    k.description && /* @__PURE__ */ e(v, { variant: "small", className: "text-muted-foreground", children: k.description })
                  ] })
                ]
              },
              k.id
            ))
          }
        ) : b || /* @__PURE__ */ e("div", { className: "text-center py-8 text-muted-foreground", children: /* @__PURE__ */ e(v, { variant: "body", children: "No options available" }) }),
        p && m && /* @__PURE__ */ e("div", { className: "mt-4 pt-4 border-t border-border", children: /* @__PURE__ */ l(
          "button",
          {
            onClick: () => z(!0),
            className: "flex items-center gap-2 w-full p-3 rounded-lg border border-dashed border-border text-muted-foreground hover:border-border-hover hover:text-foreground transition-colors",
            children: [
              /* @__PURE__ */ e(Ce, { className: "h-5 w-5" }),
              t
            ]
          }
        ) })
      ] }) })
    }
  );
}, Re = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: !1
}), Ae = (s) => {
  const a = s instanceof Date ? s : new Date(s), n = Re.formatToParts(a).reduce((r, d) => (d.type !== "literal" && (r[d.type] = d.value), r), {});
  return `${n.month} ${n.day}, ${n.year} ${n.hour}:${n.minute}:${n.second}`;
}, ze = (s) => {
  switch (s) {
    case "success":
      return "green";
    case "failure":
      return "red";
    case "warning":
      return "yellow";
    default:
      return "gray";
  }
}, kr = ({
  data: s,
  onViewDetails: a,
  ...c
}) => /* @__PURE__ */ e(
  we,
  {
    columns: [
      {
        key: "timestamp",
        header: "Timestamp",
        render: (r) => /* @__PURE__ */ e("span", { className: "text-sm text-muted-foreground", children: Ae(r.timestamp) })
      },
      {
        key: "user",
        header: "User",
        render: (r) => /* @__PURE__ */ l("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ e("span", { className: "font-medium text-sm", children: r.user.name }),
          /* @__PURE__ */ e("span", { className: "text-xs text-muted-foreground", children: r.user.email })
        ] })
      },
      {
        key: "action",
        header: "Action",
        render: (r) => /* @__PURE__ */ e("span", { className: "font-mono text-xs", children: r.action })
      },
      {
        key: "resource",
        header: "Resource",
        render: (r) => /* @__PURE__ */ e("span", { className: "text-sm", children: r.resource })
      },
      {
        key: "status",
        header: "Status",
        render: (r) => /* @__PURE__ */ e(Q, { variant: ze(r.status), children: r.status })
      }
    ],
    data: s,
    onRowClick: a ? (r) => a(r) : void 0,
    ...c
  }
), Oe = ({ id: s, checked: a, onCheckedChange: c, disabled: n, className: r }) => /* @__PURE__ */ e(
  "input",
  {
    type: "checkbox",
    id: s,
    checked: a,
    onChange: c,
    disabled: n,
    className: i(
      "h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer",
      n && "cursor-not-allowed opacity-50",
      r
    )
  }
), Cr = ({
  roles: s,
  permissions: a,
  onUpdateRolePermissions: c,
  className: n
}) => {
  var f;
  const [r, d] = A(((f = s[0]) == null ? void 0 : f.id) || ""), o = s.find((t) => t.id === r), p = a.reduce((t, u) => (t[u.category] || (t[u.category] = []), t[u.category].push(u), t), {}), h = (t) => {
    if (!o || o.isSystem) return;
    const u = o.permissions.includes(t) ? o.permissions.filter((b) => b !== t) : [...o.permissions, t];
    c(o.id, u);
  }, m = (t, u) => {
    if (!o || o.isSystem) return;
    const b = p[t].map((x) => x.id);
    let N = [...o.permissions];
    u ? b.forEach((x) => {
      N.includes(x) || N.push(x);
    }) : N = N.filter((x) => !b.includes(x)), c(o.id, N);
  };
  return /* @__PURE__ */ l("div", { className: i("grid grid-cols-1 md:grid-cols-4 gap-6 h-full", n), children: [
    /* @__PURE__ */ l("div", { className: "md:col-span-1 border-r border-border pr-6", children: [
      /* @__PURE__ */ e(v, { variant: "h4", className: "mb-4", children: "Roles" }),
      /* @__PURE__ */ e("div", { className: "flex flex-col gap-2", children: s.map((t) => /* @__PURE__ */ l(
        "button",
        {
          onClick: () => d(t.id),
          className: i(
            "flex items-center justify-between p-3 text-left rounded-md transition-colors",
            r === t.id ? "bg-primary/10 text-primary border border-primary/20" : "hover:bg-muted"
          ),
          children: [
            /* @__PURE__ */ l("div", { className: "flex flex-col gap-1", children: [
              /* @__PURE__ */ e("span", { className: "font-medium text-sm", children: t.name }),
              /* @__PURE__ */ e("span", { className: "text-xs text-muted-foreground line-clamp-1", children: t.description })
            ] }),
            t.isSystem && /* @__PURE__ */ e(be, { className: "h-4 w-4 text-muted-foreground" })
          ]
        },
        t.id
      )) })
    ] }),
    /* @__PURE__ */ e("div", { className: "md:col-span-3", children: o ? /* @__PURE__ */ l("div", { className: "flex flex-col gap-6", children: [
      /* @__PURE__ */ l("div", { className: "flex items-center justify-between pb-4 border-b border-border", children: [
        /* @__PURE__ */ l("div", { children: [
          /* @__PURE__ */ l("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ e(v, { variant: "h4", children: o.name }),
            o.isSystem && /* @__PURE__ */ e(Q, { variant: "gray", children: "System Role" })
          ] }),
          /* @__PURE__ */ e(v, { variant: "body", className: "text-muted-foreground mt-1", children: o.description })
        ] }),
        /* @__PURE__ */ l("div", { className: "flex items-center gap-2 text-sm text-muted-foreground", children: [
          o.permissions.length,
          " permissions granted"
        ] })
      ] }),
      o.isSystem && /* @__PURE__ */ l("div", { className: "bg-muted/30 p-4 rounded-md border border-border flex items-center gap-3 text-sm text-muted-foreground", children: [
        /* @__PURE__ */ e(ve, { className: "h-4 w-4" }),
        "This is a system role. Permissions cannot be modified."
      ] }),
      /* @__PURE__ */ e("div", { className: "space-y-8", children: Object.entries(p).map(([t, u]) => {
        const b = u.every((N) => o.permissions.includes(N.id));
        return u.some((N) => o.permissions.includes(N.id)), /* @__PURE__ */ l(q, { className: "overflow-hidden", children: [
          /* @__PURE__ */ l("div", { className: "bg-muted/40 p-3 border-b border-border flex items-center justify-between", children: [
            /* @__PURE__ */ e(v, { variant: "small", className: "capitalize font-semibold", children: t }),
            !o.isSystem && /* @__PURE__ */ e("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ e(
              j,
              {
                variant: "ghost",
                size: "sm",
                className: "text-xs h-7",
                onClick: () => m(t, !b),
                children: b ? "Deselect All" : "Select All"
              }
            ) })
          ] }),
          /* @__PURE__ */ e("div", { className: "divide-y divide-border", children: u.map((N) => {
            const x = o.permissions.includes(N.id);
            return /* @__PURE__ */ l(
              "div",
              {
                className: i(
                  "flex items-start gap-3 p-4 transition-colors",
                  x ? "bg-primary/5" : "hover:bg-muted/20"
                ),
                children: [
                  /* @__PURE__ */ e(
                    Oe,
                    {
                      id: `perm-${N.id}`,
                      checked: x,
                      onCheckedChange: () => h(N.id),
                      disabled: o.isSystem,
                      className: "mt-1"
                    }
                  ),
                  /* @__PURE__ */ l("div", { className: "flex flex-col gap-1", children: [
                    /* @__PURE__ */ e(
                      "label",
                      {
                        htmlFor: `perm-${N.id}`,
                        className: i(
                          "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer",
                          o.isSystem && "cursor-default"
                        ),
                        children: N.name
                      }
                    ),
                    /* @__PURE__ */ e("p", { className: "text-sm text-muted-foreground", children: N.description })
                  ] })
                ]
              },
              N.id
            );
          }) })
        ] }, t);
      }) })
    ] }) : /* @__PURE__ */ e("div", { className: "h-full flex items-center justify-center text-muted-foreground", children: "Select a role to view permissions" }) })
  ] });
}, Sr = ({
  left: s,
  right: a,
  leftWidth: c = "320px",
  stackOnMobile: n = !0,
  className: r,
  ...d
}) => /* @__PURE__ */ l(
  "div",
  {
    className: i(
      "flex h-screen w-full overflow-hidden bg-surface",
      n ? "flex-col md:flex-row" : "flex-row",
      r
    ),
    ...d,
    children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: i(
            "flex-shrink-0 overflow-y-auto border-r border-border bg-background",
            n ? "w-full md:w-[var(--left-width)] h-[300px] md:h-full" : "w-[var(--left-width)] h-full"
          ),
          style: {
            "--left-width": typeof c == "number" ? `${c}px` : c
          },
          children: s
        }
      ),
      /* @__PURE__ */ e("div", { className: "flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-6", children: a })
    ]
  }
), Le = ({ children: s, className: a }) => /* @__PURE__ */ e("div", { className: i("flex h-screen w-full bg-background text-foreground", a), children: s }), Be = ({ children: s, className: a }) => /* @__PURE__ */ e("aside", { className: i("border-r border-border hidden lg:flex flex-col", a), children: s }), _e = ({ children: s, className: a }) => /* @__PURE__ */ e("div", { className: i("flex-1 flex flex-col min-w-0", a), children: s }), Fe = ({ children: s, className: a }) => /* @__PURE__ */ e("header", { className: i("h-16 border-b border-border bg-background sticky top-0 z-10 w-full", a), children: s }), qe = ({ children: s, className: a }) => /* @__PURE__ */ e("main", { className: i("flex-1 overflow-auto bg-muted/5 p-6", a), children: s }), $r = ({
  logo: s,
  navItems: a = [],
  headerCTAs: c = [],
  children: n,
  footer: r,
  simpleFooter: d,
  showNavigation: o = !0,
  showFooter: p = !0,
  linkComponent: h = "a",
  stickyHeader: m = !0,
  transparentHeader: f = !0,
  className: t,
  ...u
}) => {
  const b = (x, w, y) => /* @__PURE__ */ e(h, { href: x, children: w }), N = (x) => {
    const w = x.variant === "primary" ? "primary" : x.variant === "secondary" ? "secondary" : "outline", y = /* @__PURE__ */ e(
      j,
      {
        variant: w,
        size: "sm",
        onClick: x.onClick,
        children: x.label
      }
    );
    return x.href ? b(x.href, y) : y;
  };
  return /* @__PURE__ */ l("div", { className: i("min-h-screen bg-background", t), ...u, children: [
    /* @__PURE__ */ e(
      "header",
      {
        className: i(
          "z-50 border-b border-border",
          m && "sticky top-0",
          f ? "bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60" : "bg-background"
        ),
        children: /* @__PURE__ */ e("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children: /* @__PURE__ */ l("div", { className: "flex h-16 items-center justify-between", children: [
          /* @__PURE__ */ e("div", { className: "flex-shrink-0", children: s }),
          o && a.length > 0 && /* @__PURE__ */ e("nav", { className: "hidden md:flex items-center gap-8", children: a.map((x) => /* @__PURE__ */ e(
            h,
            {
              href: x.href,
              className: "text-sm font-medium text-muted-foreground hover:text-foreground transition-colors",
              ...x.isExternal && { target: "_blank", rel: "noopener noreferrer" },
              children: x.label
            },
            x.href
          )) }),
          c.length > 0 && /* @__PURE__ */ e("div", { className: "flex items-center gap-3", children: c.map((x, w) => /* @__PURE__ */ e(_.Fragment, { children: N(x) }, w)) })
        ] }) })
      }
    ),
    /* @__PURE__ */ e("main", { children: n }),
    p && (r || d) && /* @__PURE__ */ e(V, { children: r || (d ? /* @__PURE__ */ e("footer", { className: "border-t border-border bg-muted/30", children: /* @__PURE__ */ e("div", { className: "mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8", children: /* @__PURE__ */ l("div", { className: "flex flex-col items-center justify-between gap-6 md:flex-row", children: [
      d.logo && /* @__PURE__ */ e("div", { className: "flex-shrink-0", children: d.logo }),
      d.navItems && d.navItems.length > 0 && /* @__PURE__ */ e("nav", { className: "flex items-center gap-6 text-sm text-muted-foreground", children: d.navItems.map((x) => /* @__PURE__ */ e(
        h,
        {
          href: x.href,
          className: "hover:text-foreground transition-colors",
          ...x.isExternal && { target: "_blank", rel: "noopener noreferrer" },
          children: x.label
        },
        x.href
      )) }),
      d.copyright && /* @__PURE__ */ e("p", { className: "text-sm text-muted-foreground", children: d.copyright })
    ] }) }) }) : null) })
  ] });
}, Ke = ({
  sidebar: s,
  header: a,
  children: c,
  className: n
}) => /* @__PURE__ */ l(Le, { className: n, children: [
  s && /* @__PURE__ */ e(Be, { children: s }),
  /* @__PURE__ */ l(_e, { children: [
    a && /* @__PURE__ */ e(Fe, { children: a }),
    /* @__PURE__ */ e(qe, { children: /* @__PURE__ */ e(J, { children: c }) })
  ] }),
  /* @__PURE__ */ e(Z, {})
] }), Pr = Ke, jr = ({
  sidebar: s,
  children: a,
  className: c
}) => /* @__PURE__ */ l("div", { className: i("min-h-screen bg-background text-foreground flex flex-col md:flex-row max-w-7xl mx-auto p-6 gap-8", c), children: [
  /* @__PURE__ */ e("aside", { className: "w-full md:w-64 flex-shrink-0", children: s }),
  /* @__PURE__ */ e("main", { className: "flex-1 min-w-0", children: /* @__PURE__ */ e(J, { children: a }) }),
  /* @__PURE__ */ e(Z, {})
] }), Dr = ({
  children: s,
  className: a,
  maxWidthClass: c = "max-w-3xl"
}) => /* @__PURE__ */ l("div", { className: i("min-h-screen bg-muted/10 flex items-center justify-center p-4", a), children: [
  /* @__PURE__ */ e("div", { className: i("w-full space-y-8", c), children: /* @__PURE__ */ e(J, { children: s }) }),
  /* @__PURE__ */ e(Z, {})
] }), Er = ({
  items: s,
  variant: a = "default",
  className: c,
  onLoadMore: n
}) => {
  const r = a === "compact";
  return /* @__PURE__ */ l("div", { className: i("w-full", c), children: [
    /* @__PURE__ */ e("div", { className: i(
      "relative border-l border-border ml-4",
      r ? "space-y-4 py-2" : "space-y-8 py-4"
    ), children: s.map((d) => /* @__PURE__ */ l("div", { className: "relative pl-8", children: [
      /* @__PURE__ */ e("div", { className: i(
        "absolute left-[-5px] rounded-full ring-4 ring-background",
        r ? "top-1.5 h-2 w-2" : "top-1 h-2.5 w-2.5",
        d.variant === "primary" ? "bg-primary" : d.variant === "warning" ? "bg-warning" : d.variant === "success" ? "bg-success" : d.variant === "destructive" ? "bg-destructive" : "bg-muted-foreground"
      ) }),
      /* @__PURE__ */ l("div", { className: "flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2", children: [
        /* @__PURE__ */ l("div", { className: "space-y-1 flex-1", children: [
          /* @__PURE__ */ l("div", { className: "flex items-center gap-2 flex-wrap", children: [
            d.user && /* @__PURE__ */ e("span", { className: "font-semibold text-sm", children: d.user.name }),
            /* @__PURE__ */ e("span", { className: "text-sm text-muted-foreground", children: d.action }),
            d.target && /* @__PURE__ */ e("span", { className: "font-medium text-sm", children: d.target })
          ] }),
          !r && /* @__PURE__ */ e("p", { className: "text-xs text-muted-foreground", children: d.timestamp })
        ] }),
        r && /* @__PURE__ */ e("p", { className: "text-xs text-muted-foreground whitespace-nowrap", children: d.timestamp })
      ] })
    ] }, d.id)) }),
    n && /* @__PURE__ */ e("div", { className: "text-center pt-4", children: /* @__PURE__ */ e(j, { variant: "ghost", onClick: n, children: "Load More Activity" }) })
  ] });
}, Tr = ({
  title: s,
  description: a,
  breadcrumbs: c,
  actions: n,
  isLoading: r,
  loadingMessage: d,
  error: o,
  errorTitle: p,
  errorDescription: h,
  onRetry: m,
  isEmpty: f,
  emptyState: t,
  children: u,
  className: b,
  ...N
}) => {
  const x = () => {
    if (h) return h;
    if (o instanceof Error) return o.message;
  };
  return /* @__PURE__ */ l("div", { className: i("flex flex-col gap-6 h-full", b), ...N, children: [
    /* @__PURE__ */ e(
      le,
      {
        title: s,
        description: a,
        breadcrumbs: c,
        actions: n
      }
    ),
    /* @__PURE__ */ e("div", { className: "flex-1 flex flex-col min-h-0", children: r ? /* @__PURE__ */ e("div", { className: "flex-1 flex items-center justify-center min-h-[400px]", children: /* @__PURE__ */ e(ce, { message: d }) }) : o ? /* @__PURE__ */ e("div", { className: "flex-1 flex items-center justify-center min-h-[400px]", children: /* @__PURE__ */ e(
      de,
      {
        title: p,
        description: x(),
        onRetry: m
      }
    ) }) : f && t ? /* @__PURE__ */ e("div", { className: "flex-1 flex items-center justify-center min-h-[400px]", children: /* @__PURE__ */ e(ke, { ...t }) }) : u })
  ] });
}, Ve = ({
  title: s,
  description: a,
  breadcrumbs: c,
  actions: n,
  isLoading: r,
  loadingMessage: d,
  error: o,
  errorTitle: p,
  errorDescription: h,
  onRetry: m,
  children: f,
  className: t,
  ...u
}) => {
  const b = () => {
    if (h) return h;
    if (o instanceof Error) return o.message;
  };
  return /* @__PURE__ */ l("div", { className: i("flex flex-col gap-6", t), ...u, children: [
    /* @__PURE__ */ e(
      le,
      {
        title: s,
        description: a,
        breadcrumbs: c,
        actions: n
      }
    ),
    /* @__PURE__ */ e("div", { className: "flex-1", children: r ? /* @__PURE__ */ e("div", { className: "py-12", children: /* @__PURE__ */ e(ce, { message: d }) }) : o ? /* @__PURE__ */ e("div", { className: "py-12", children: /* @__PURE__ */ e(
      de,
      {
        title: p,
        description: b(),
        onRetry: m
      }
    ) }) : f })
  ] });
}, Ir = ({
  maxWidth: s = "lg",
  children: a,
  className: c,
  ...n
}) => {
  const r = {
    sm: "max-w-screen-sm",
    md: "max-w-screen-md",
    lg: "max-w-screen-lg",
    xl: "max-w-screen-xl",
    "2xl": "max-w-screen-2xl",
    full: "max-w-full"
  }[s];
  return /* @__PURE__ */ e(
    Ve,
    {
      className: c,
      ...n,
      children: /* @__PURE__ */ e("div", { className: i("w-full", s !== "full" && r), children: a })
    }
  );
}, We = {
  sm: "py-12 lg:py-16",
  md: "py-16 lg:py-24",
  lg: "py-20 lg:py-32"
}, Rr = ({
  headline: s,
  headlineHighlight: a,
  description: c,
  ctas: n = [],
  visual: r,
  layout: d = "split",
  background: o = "gradient",
  gradientFrom: p = "from-primary/5",
  gradientTo: h = "to-background",
  size: m = "md",
  linkComponent: f = "a",
  className: t,
  ...u
}) => {
  const b = (y, S) => {
    const E = y.variant === "primary" ? "primary" : y.variant === "secondary" ? "secondary" : "outline", T = /* @__PURE__ */ l(
      j,
      {
        variant: E,
        size: "lg",
        onClick: y.onClick,
        children: [
          y.label,
          y.icon && /* @__PURE__ */ e("span", { className: "ml-2", children: y.icon })
        ]
      },
      S
    );
    return y.href ? /* @__PURE__ */ e(f, { href: y.href, children: T }, S) : T;
  }, N = o === "gradient" ? `bg-gradient-to-b ${p} ${h}` : o === "solid" ? "bg-muted/30" : "", x = d === "centered", w = d === "split-reverse";
  return /* @__PURE__ */ e(
    "section",
    {
      className: i(
        "relative overflow-hidden",
        N,
        We[m],
        t
      ),
      ...u,
      children: /* @__PURE__ */ e("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children: x ? (
        // Centered Layout
        /* @__PURE__ */ l("div", { className: "text-center max-w-3xl mx-auto", children: [
          /* @__PURE__ */ l(v, { variant: "h1", className: "text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight", children: [
            s,
            " ",
            a && /* @__PURE__ */ e("span", { className: "text-primary", children: a })
          ] }),
          c && /* @__PURE__ */ e(
            v,
            {
              variant: "body-lg",
              className: "mt-6 text-muted-foreground max-w-2xl mx-auto",
              children: c
            }
          ),
          n.length > 0 && /* @__PURE__ */ e("div", { className: "mt-8 flex flex-wrap justify-center gap-4", children: n.map((y, S) => b(y, S)) }),
          r && /* @__PURE__ */ e("div", { className: "mt-12", children: r })
        ] })
      ) : (
        // Split Layout
        /* @__PURE__ */ l(
          "div",
          {
            className: i(
              "grid gap-12 lg:grid-cols-2 lg:gap-8 items-center",
              w && "lg:grid-flow-dense"
            ),
            children: [
              /* @__PURE__ */ l("div", { className: i("max-w-xl", w && "lg:col-start-2"), children: [
                /* @__PURE__ */ l(v, { variant: "h1", className: "text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight", children: [
                  s,
                  " ",
                  a && /* @__PURE__ */ e("span", { className: "text-primary", children: a })
                ] }),
                c && /* @__PURE__ */ e(
                  v,
                  {
                    variant: "body-lg",
                    className: "mt-6 text-muted-foreground",
                    children: c
                  }
                ),
                n.length > 0 && /* @__PURE__ */ e("div", { className: "mt-8 flex flex-wrap gap-4", children: n.map((y, S) => b(y, S)) })
              ] }),
              r && /* @__PURE__ */ e("div", { className: i("relative", w && "lg:col-start-1"), children: r })
            ]
          }
        )
      ) })
    }
  );
}, Me = {
  2: "grid-cols-1 md:grid-cols-2",
  3: "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
  4: "grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
  5: "grid-cols-2 md:grid-cols-3 lg:grid-cols-5"
}, Ar = ({
  heading: s,
  subheading: a,
  features: c,
  columns: n = 3,
  variant: r = "cards",
  centerHeader: d = !0,
  linkComponent: o = "a",
  className: p,
  ...h
}) => {
  const m = (f, t) => {
    const u = /* @__PURE__ */ l(V, { children: [
      f.icon && /* @__PURE__ */ e(
        "div",
        {
          className: i(
            "flex items-center justify-center mb-4",
            r === "cards" ? "h-12 w-12 rounded-xl" : r === "icons" ? "h-16 w-16 rounded-xl mx-auto" : "h-8 w-8",
            f.iconColorClass || "bg-primary/10 text-primary"
          ),
          children: /* @__PURE__ */ e("span", { className: i(r === "icons" ? "h-8 w-8" : "h-6 w-6"), children: f.icon })
        }
      ),
      /* @__PURE__ */ e(
        v,
        {
          variant: r === "minimal" ? "body" : "h4",
          className: i(
            "font-semibold",
            r === "icons" && "text-center",
            f.href && "group-hover:text-primary transition-colors"
          ),
          children: f.title
        }
      ),
      f.description && /* @__PURE__ */ e(
        v,
        {
          variant: "small",
          className: i(
            "text-muted-foreground mt-1",
            r === "icons" && "text-center"
          ),
          children: f.description
        }
      )
    ] }), b = i(
      "group",
      r === "cards" && "transition-all hover:shadow-lg hover:-translate-y-1",
      r === "icons" && "text-center transition-transform hover:-translate-y-1",
      f.href && "cursor-pointer"
    );
    return r === "cards" ? f.href ? /* @__PURE__ */ e(o, { href: f.href, className: "block", children: /* @__PURE__ */ e(q, { className: i("p-6", b), children: u }) }, t) : /* @__PURE__ */ e(q, { className: i("p-6", b), children: u }, t) : f.href ? /* @__PURE__ */ e(o, { href: f.href, className: i("block", b), children: u }, t) : /* @__PURE__ */ e("div", { className: b, children: u }, t);
  };
  return /* @__PURE__ */ e("section", { className: i("py-16 lg:py-20", p), ...h, children: /* @__PURE__ */ l("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children: [
    (s || a) && /* @__PURE__ */ l("div", { className: i("mb-12", d && "text-center"), children: [
      s && /* @__PURE__ */ e(v, { variant: "h2", className: "text-3xl font-bold", children: s }),
      a && /* @__PURE__ */ e(
        v,
        {
          variant: "body-lg",
          className: "mt-4 text-muted-foreground max-w-2xl mx-auto",
          children: a
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { className: i("grid gap-6", Me[n]), children: c.map((f, t) => m(f, t)) })
  ] }) });
}, zr = ({
  heading: s,
  subheading: a,
  steps: c,
  variant: n = "horizontal",
  style: r = "numbers",
  showConnectors: d = !0,
  centerHeader: o = !0,
  background: p = "muted",
  className: h,
  ...m
}) => {
  const f = n === "horizontal";
  return /* @__PURE__ */ e(
    "section",
    {
      className: i(
        "py-16 lg:py-20",
        p === "muted" && "bg-muted/30",
        h
      ),
      ...m,
      children: /* @__PURE__ */ l("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children: [
        (s || a) && /* @__PURE__ */ l("div", { className: i("mb-12", o && "text-center"), children: [
          s && /* @__PURE__ */ e(v, { variant: "h2", className: "text-3xl font-bold", children: s }),
          a && /* @__PURE__ */ e(
            v,
            {
              variant: "body-lg",
              className: "mt-4 text-muted-foreground",
              children: a
            }
          )
        ] }),
        /* @__PURE__ */ e(
          "div",
          {
            className: i(
              f ? "grid md:grid-cols-3 gap-8" : "flex flex-col gap-8 max-w-2xl mx-auto"
            ),
            children: c.map((t, u) => {
              const b = t.number ?? u + 1, N = u === c.length - 1;
              return /* @__PURE__ */ l(
                "div",
                {
                  className: i(
                    "relative",
                    f && "text-center"
                  ),
                  children: [
                    f && d && !N && /* @__PURE__ */ e("div", { className: "hidden md:block absolute top-8 left-[60%] w-[80%] h-0.5 bg-primary/20" }),
                    /* @__PURE__ */ l(
                      "div",
                      {
                        className: i(
                          "flex flex-col",
                          f ? "items-center" : "flex-row items-start gap-4"
                        ),
                        children: [
                          /* @__PURE__ */ e(
                            "div",
                            {
                              className: i(
                                "flex shrink-0 items-center justify-center rounded-full font-bold text-primary-foreground",
                                r === "timeline" ? "h-4 w-4 bg-primary" : "h-16 w-16 bg-primary text-2xl"
                              ),
                              children: r === "icons" && t.icon ? /* @__PURE__ */ e("span", { className: "h-8 w-8", children: t.icon }) : r !== "timeline" ? b : null
                            }
                          ),
                          /* @__PURE__ */ l("div", { className: i(f && "mt-4"), children: [
                            !f && d && !N && r === "timeline" && /* @__PURE__ */ e("div", { className: "absolute left-2 top-4 w-0.5 h-full bg-primary/20 -translate-x-1/2" }),
                            /* @__PURE__ */ e(
                              v,
                              {
                                variant: "h4",
                                className: i("font-semibold mb-2", f && "text-xl"),
                                children: t.title
                              }
                            ),
                            t.description && /* @__PURE__ */ e(
                              v,
                              {
                                variant: "body",
                                className: "text-muted-foreground",
                                children: t.description
                              }
                            )
                          ] })
                        ]
                      }
                    )
                  ]
                },
                u
              );
            })
          }
        )
      ] })
    }
  );
}, Or = ({
  heading: s,
  subheading: a,
  plans: c,
  centerHeader: n = !0,
  linkComponent: r = "a",
  background: d = "muted",
  className: o,
  ...p
}) => {
  const h = c.length === 1 ? "max-w-md" : c.length === 2 ? "md:grid-cols-2 max-w-4xl" : c.length === 3 ? "md:grid-cols-3 max-w-5xl" : "md:grid-cols-2 lg:grid-cols-4 max-w-6xl";
  return /* @__PURE__ */ e(
    "section",
    {
      className: i(
        "py-16 lg:py-20",
        d === "muted" && "bg-muted/30",
        o
      ),
      ...p,
      children: /* @__PURE__ */ l("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children: [
        (s || a) && /* @__PURE__ */ l("div", { className: i("mb-12", n && "text-center"), children: [
          s && /* @__PURE__ */ e(v, { variant: "h2", className: "text-3xl font-bold", children: s }),
          a && /* @__PURE__ */ e(
            v,
            {
              variant: "body-lg",
              className: "mt-4 text-muted-foreground",
              children: a
            }
          )
        ] }),
        /* @__PURE__ */ e("div", { className: i("grid gap-8 mx-auto", h), children: c.map((m, f) => {
          const t = /* @__PURE__ */ e(
            j,
            {
              variant: m.featured ? "primary" : "outline",
              className: "w-full",
              onClick: m.ctaOnClick,
              children: m.ctaLabel || "Get Started"
            }
          );
          return /* @__PURE__ */ l(
            q,
            {
              className: i(
                "p-8 relative flex flex-col",
                m.featured && "border-2 border-primary ring-1 ring-primary/10"
              ),
              children: [
                m.badge && /* @__PURE__ */ l(
                  Q,
                  {
                    className: i(
                      "absolute -top-3 left-1/2 -translate-x-1/2",
                      m.featured && "bg-primary text-primary-foreground"
                    ),
                    children: [
                      m.badgeIcon && /* @__PURE__ */ e("span", { className: "h-3 w-3 mr-1", children: m.badgeIcon }),
                      m.badge
                    ]
                  }
                ),
                /* @__PURE__ */ e(v, { variant: "h3", className: "text-xl font-semibold mb-2", children: m.name }),
                m.description && /* @__PURE__ */ e(v, { variant: "small", className: "text-muted-foreground mb-4", children: m.description }),
                /* @__PURE__ */ l("div", { className: "mb-6", children: [
                  /* @__PURE__ */ e("span", { className: "text-4xl font-bold", children: m.price }),
                  m.priceSuffix && /* @__PURE__ */ e("span", { className: "text-muted-foreground", children: m.priceSuffix })
                ] }),
                /* @__PURE__ */ e("ul", { className: "space-y-3 mb-8 flex-1", children: m.features.map((u, b) => /* @__PURE__ */ l(
                  "li",
                  {
                    className: i(
                      "flex items-center gap-2",
                      u.included === !1 && "text-muted-foreground line-through"
                    ),
                    children: [
                      /* @__PURE__ */ e(
                        ae,
                        {
                          className: i(
                            "h-5 w-5 flex-shrink-0",
                            u.included === !1 ? "text-muted-foreground/50" : "text-green-500"
                          )
                        }
                      ),
                      /* @__PURE__ */ e("span", { children: u.text })
                    ]
                  },
                  b
                )) }),
                m.ctaHref ? /* @__PURE__ */ e(r, { href: m.ctaHref, className: "block", children: t }) : t
              ]
            },
            f
          );
        }) })
      ] })
    }
  );
}, He = {
  1: "max-w-2xl",
  2: "md:grid-cols-2 max-w-4xl",
  3: "md:grid-cols-2 lg:grid-cols-3 max-w-6xl",
  4: "md:grid-cols-2 lg:grid-cols-4 max-w-7xl"
}, Lr = ({
  heading: s,
  subheading: a,
  testimonials: c,
  columns: n = 3,
  variant: r = "cards",
  showRatings: d = !0,
  centerHeader: o = !0,
  className: p,
  ...h
}) => {
  const m = (t) => /* @__PURE__ */ e("div", { className: "flex gap-0.5", children: Array.from({ length: 5 }).map((u, b) => /* @__PURE__ */ e(
    Ne,
    {
      className: i(
        "h-5 w-5",
        b < t ? "fill-yellow-400 text-yellow-400" : "fill-muted text-muted"
      )
    },
    b
  )) }), f = (t, u) => {
    const b = /* @__PURE__ */ l(V, { children: [
      d && t.rating && /* @__PURE__ */ e("div", { className: "mb-4", children: m(t.rating) }),
      /* @__PURE__ */ e(
        v,
        {
          variant: "body",
          className: i(
            "mb-4",
            r === "quotes" && "text-lg italic",
            r === "minimal" && "text-muted-foreground"
          ),
          children: r === "quotes" ? `"${t.quote}"` : `"${t.quote}"`
        }
      ),
      /* @__PURE__ */ l("div", { className: "flex items-center gap-3", children: [
        t.avatarUrl && /* @__PURE__ */ e(
          Te,
          {
            src: t.avatarUrl,
            fallback: t.author,
            size: "md"
          }
        ),
        /* @__PURE__ */ l("div", { children: [
          /* @__PURE__ */ e(v, { variant: "body", className: "font-semibold", children: t.author }),
          (t.role || t.company) && /* @__PURE__ */ l(v, { variant: "small", className: "text-muted-foreground", children: [
            t.role,
            t.role && t.company && ", ",
            t.company
          ] })
        ] })
      ] })
    ] });
    return r === "cards" ? /* @__PURE__ */ e(q, { className: "p-6", children: b }, u) : /* @__PURE__ */ e("div", { className: i(r === "quotes" && "border-l-4 border-primary pl-6"), children: b }, u);
  };
  return /* @__PURE__ */ e("section", { className: i("py-16 lg:py-20", p), ...h, children: /* @__PURE__ */ l("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children: [
    (s || a) && /* @__PURE__ */ l("div", { className: i("mb-12", o && "text-center"), children: [
      s && /* @__PURE__ */ e(v, { variant: "h2", className: "text-3xl font-bold", children: s }),
      a && /* @__PURE__ */ e(
        v,
        {
          variant: "body-lg",
          className: "mt-4 text-muted-foreground",
          children: a
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { className: i("grid gap-8 mx-auto", He[n]), children: c.map(
      (t, u) => f(t, u)
    ) })
  ] }) });
}, Ue = {
  sm: "py-12",
  md: "py-16 lg:py-20",
  lg: "py-20 lg:py-28"
}, Ge = {
  primary: "bg-primary text-primary-foreground",
  dark: "bg-foreground text-background",
  gradient: "bg-gradient-to-r from-primary to-primary/80 text-primary-foreground",
  muted: "bg-muted text-foreground"
}, Br = ({
  headline: s,
  description: a,
  primaryCTA: c,
  secondaryCTA: n,
  variant: r = "primary",
  layout: d = "centered",
  size: o = "md",
  linkComponent: p = "a",
  className: h,
  ...m
}) => {
  const f = d === "centered", t = (u, b) => {
    const N = b ? r === "muted" ? "primary" : "secondary" : r === "muted" ? "outline" : "ghost", x = i(
      !b && r !== "muted" && "text-current border-current/20 hover:bg-current/10"
    ), w = /* @__PURE__ */ l(
      j,
      {
        variant: N,
        size: "lg",
        onClick: u.onClick,
        className: x,
        children: [
          u.label,
          u.icon && /* @__PURE__ */ e("span", { className: "ml-2", children: u.icon })
        ]
      }
    );
    return u.href ? /* @__PURE__ */ e(p, { href: u.href, children: w }) : w;
  };
  return /* @__PURE__ */ e(
    "section",
    {
      className: i(Ge[r], Ue[o], h),
      ...m,
      children: /* @__PURE__ */ e("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children: f ? (
        // Centered Layout
        /* @__PURE__ */ l("div", { className: "text-center", children: [
          /* @__PURE__ */ e(v, { variant: "h2", className: "text-3xl font-bold mb-4", children: s }),
          a && /* @__PURE__ */ e(
            v,
            {
              variant: "body-lg",
              className: i(
                "mb-8 max-w-2xl mx-auto",
                r === "primary" || r === "dark" || r === "gradient" ? "opacity-90" : "text-muted-foreground"
              ),
              children: a
            }
          ),
          /* @__PURE__ */ l("div", { className: "flex flex-wrap justify-center gap-4", children: [
            c && t(c, !0),
            n && t(n, !1)
          ] })
        ] })
      ) : (
        // Split Layout
        /* @__PURE__ */ l("div", { className: "flex flex-col lg:flex-row items-center justify-between gap-8", children: [
          /* @__PURE__ */ l("div", { className: "text-center lg:text-left", children: [
            /* @__PURE__ */ e(v, { variant: "h2", className: "text-3xl font-bold mb-2", children: s }),
            a && /* @__PURE__ */ e(
              v,
              {
                variant: "body-lg",
                className: i(
                  r === "primary" || r === "dark" || r === "gradient" ? "opacity-90" : "text-muted-foreground"
                ),
                children: a
              }
            )
          ] }),
          /* @__PURE__ */ l("div", { className: "flex flex-wrap gap-4", children: [
            c && t(c, !0),
            n && t(n, !1)
          ] })
        ] })
      ) })
    }
  );
}, Je = _.forwardRef(
  ({ className: s, title: a, count: c, headerAction: n, children: r, testId: d, ...o }, p) => /* @__PURE__ */ l(
    "section",
    {
      ref: p,
      "data-testid": d,
      className: i(
        "flex flex-col min-w-[280px] max-w-[360px] h-full",
        "bg-surface-secondary/50 rounded-lg border border-border",
        s
      ),
      ...o,
      children: [
        /* @__PURE__ */ l("header", { className: "flex items-center justify-between p-3 border-b border-border/50", children: [
          /* @__PURE__ */ l("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ e("h3", { className: "text-sm font-semibold text-content-primary", children: a }),
            c !== void 0 && /* @__PURE__ */ e("span", { className: "px-2 py-0.5 text-xs font-medium bg-surface-overlay text-content-secondary rounded-full", children: c })
          ] }),
          n && /* @__PURE__ */ e("div", { children: n })
        ] }),
        /* @__PURE__ */ e("div", { className: "flex-1 overflow-y-auto p-2 gap-2 flex flex-col", children: r })
      ]
    }
  )
);
Je.displayName = "KanbanColumn";
const Qe = _.forwardRef(
  ({ className: s, children: a, isDragging: c, title: n, assignee: r, priority: d, testId: o, ...p }, h) => /* @__PURE__ */ l(
    "div",
    {
      ref: h,
      "data-testid": o,
      role: "listitem",
      className: i(
        "p-3 rounded bg-surface text-content-primary shadow-sm border border-border",
        "hover:border-border-hover transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus",
        c && "opacity-50 shadow-lg cursor-grabbing",
        !c && "cursor-grab",
        s
      ),
      ...p,
      children: [
        (n || r || d) && /* @__PURE__ */ l("div", { className: "mb-2 space-y-1", children: [
          n && /* @__PURE__ */ e("div", { className: "text-sm font-medium", children: n }),
          (r || d) && /* @__PURE__ */ l("div", { className: "flex items-center gap-2 text-xs text-content-secondary", children: [
            r && /* @__PURE__ */ e("span", { children: r }),
            d && /* @__PURE__ */ e("span", { children: d })
          ] })
        ] }),
        a
      ]
    }
  )
);
Qe.displayName = "KanbanCard";
const Ze = _.forwardRef(
  ({ className: s, children: a, testId: c, ...n }, r) => /* @__PURE__ */ e(
    "div",
    {
      ref: r,
      "data-testid": c,
      className: i(
        "relative w-full h-full overflow-hidden bg-surface-secondary",
        "bg-[radial-gradient(var(--ds-color-border-hover)_1px,transparent_1px)] [background-size:16px_16px]",
        s
      ),
      ...n,
      children: /* @__PURE__ */ e("div", { className: "absolute inset-0 w-full h-full transform-gpu", children: a })
    }
  )
);
Ze.displayName = "WorkflowBuilder";
const Ye = _.forwardRef(
  ({ className: s, x: a, y: c, selected: n, children: r, testId: d, style: o, ...p }, h) => /* @__PURE__ */ e(
    "div",
    {
      ref: h,
      "data-testid": d,
      tabIndex: 0,
      "aria-selected": n,
      style: {
        transform: `translate(${a}px, ${c}px)`,
        ...o
      },
      className: i(
        "absolute top-0 left-0",
        "min-w-[150px] bg-surface rounded-lg shadow-md border",
        n ? "border-focus ring-2 ring-focus/20" : "border-border",
        "focus:outline-none focus:ring-2 focus:ring-focus",
        "cursor-default",
        // or grab/move if draggable
        s
      ),
      ...p,
      children: r
    }
  )
);
Ye.displayName = "WorkflowNode";
const Xe = _.forwardRef(
  ({ className: s, sourceX: a, sourceY: c, targetX: n, targetY: r, selected: d, testId: o, ...p }, h) => {
    const m = Math.abs(n - a), f = Math.max(m * 0.5, 50), t = `M ${a} ${c} C ${a + f} ${c}, ${n - f} ${r}, ${n} ${r}`;
    return /* @__PURE__ */ e("svg", { className: "absolute inset-0 pointer-events-none overflow-visible w-full h-full", children: /* @__PURE__ */ e(
      "path",
      {
        ref: h,
        d: t,
        "data-testid": o,
        fill: "none",
        strokeWidth: 2,
        className: i(
          "transition-colors duration-200 pointer-events-auto cursor-pointer",
          d ? "stroke-focus" : "stroke-border-hover",
          "hover:stroke-content-secondary",
          s
        ),
        ...p
      }
    ) });
  }
);
Xe.displayName = "WorkflowEdge";
export {
  kr as A,
  Nr as C,
  Ie as D,
  br as F,
  Rr as H,
  Je as K,
  Tr as L,
  Dr as O,
  Cr as P,
  wr as S,
  Z as T,
  Ze as W,
  vr as a,
  yr as b,
  Sr as c,
  Le as d,
  Be as e,
  _e as f,
  Fe as g,
  qe as h,
  $r as i,
  Ke as j,
  Pr as k,
  jr as l,
  Er as m,
  Ve as n,
  Ir as o,
  Ar as p,
  zr as q,
  Or as r,
  Lr as s,
  Br as t,
  Qe as u,
  Ye as v,
  Xe as w
};
